import { Component, NgZone } from '@angular/core';
import { ActionSheetController, IonicPage, NavController, NavParams } from 'ionic-angular';
import { APIServiceProvider } from '../../common/services/api.service';
import { HelperServiceProvider } from '../../common/services/helper.service';
import { NotifyService } from '../../services/notify.service';

/**
 * Generated class for the PagesBankReceiptPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-pages-bank-receipt',
  templateUrl: 'pages-bank-receipt.html',
})
export class PagesBankReceiptPage {
  public getCustomersUrl = "customer/get-fieldstaff-customers"; 
  public disabledAction: any = false;  

  maxDate=new Date() 

  fileObj: any = null;
  fileName: any = null;
 
  hideback: any = false;
  postData:any = {};

   fileData: any = null;
  filetype: any = 'img';
  filename: any = null;
  filesrc: any = null;
  imagetype: any = ['jpeg', 'png', 'jpg', 'gif']; 

  formObjData: any = {
    file: null,
    amount: null,
    submitted_date: null,
    bank: null,
    comment: null
  };

  public customOptions: any = {
    header: "Select bank"
  };

  public banks: any = [];

  constructor(
    private apiService: APIServiceProvider,
    private notifyService: NotifyService,
     public actionSheetCtrl: ActionSheetController,
      public zone: NgZone,
    public helper: HelperServiceProvider,
  ) { 
  }

  ngOnInit() {
    this.getBankReceipt();
  }

  ngOnDestroy() {
    this.deleteFile();
 }

  async openChooser() {
 
    let self = this;

    let actionSheet = await this.actionSheetCtrl.create({
      title: 'Select Receipt',
      buttons: [{
        text: 'Camera',
        role: 'destructive',
        icon: 'camera',
        handler: () => {
          this.pickFromGallery(this, 'camera');
        }
      }, {
        text: 'Gallery',
        icon: 'images',
        handler: () => {
          this.pickFromGallery(this, 'gallery');
        }
      }]
    });

    await actionSheet.present();
  }
  calenderFocusOut(ev){
    if(new Date(this.formObjData.submitted_date) > new Date() && new Date(this.formObjData.submitted_date).getDate() && new Date(this.formObjData.submitted_date).getMonth() &&  new Date(this.formObjData.submitted_date).getFullYear()) {
      this.formObjData.submitted_date = ''
      this.helper.presentToast("Please enter valid date");

    }
  }
  upload12(event) {
    const file = event.target.files[0]; 
    this.fileData = file

    this.fileObj = this.fileData;
    this.fileName = this.fileObj.name;

    const reader = new FileReader();
    
    if(event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
    
      reader.onload = () => {
   
        this.filesrc = reader.result as string;
      
      };
    } 

  }
  pickFromGallery(self, type) { 
    self.deviceService.pickFromGallery(type, function(path) { 

      self.zone.run(() => { 
        self.filesrc = path.display_url; 
        self.fileData = path;
        self.filename = path.fileObject.name; 
      }); 

    }); 
  } 

  deleteFile() {
      this.fileData = null;
    this.filename = null;
    this.filetype = null;
    this.filesrc = null;

    this.formObjData = {
      file: null,
      amount: null,
      submitted_date: null,
      bank: null
    };
  }

  getBankReceipt() {
    this.apiService.get('order/finance/get-bank-receipt-names').subscribe(response => {
       this.banks = response['data'];
    });
  }
  uploadBankReceipt() {

    if(!this.formObjData.amount || parseInt(this.formObjData.amount) < 1 || parseInt(this.formObjData.amount) > 10000000) {
      this.helper.presentToast("Please enter valid amount");
      return true;
    }

    if(!this.formObjData.submitted_date) {
      this.helper.presentToast("Please enter valid date");
      return true;
    }

    if(!this.formObjData.bank) {
      this.helper.presentToast("Please choose the bank");
      return true;
    }

    if(!this.fileData) {
      this.helper.presentToast("Please upload receipt");
      return true;
    }  

    var formData = new FormData()
    formData.append('receipt', this.fileObj, this.fileName);
    formData.append('amount', this.formObjData.amount);
    formData.append('deposited_datetime', this.formObjData.submitted_date);
    formData.append('bank_account_name', this.formObjData.bank);
    formData.append('upload_comments', this.formObjData.comment);

    this.disabledAction = true; 
    this.apiService.postMultiPart("order/finance/upload-bank-receipts", formData).subscribe(response => {

      this.disabledAction = false; 

      if(response['data']) {
        this.helper.presentToast(response['data']['message']);
        this.deleteFile();
      } 
       
    },  error => {
       this.disabledAction = false; 
    });

  }
 
}


// WEBPACK FOOTER //
// ./src/pages/pages-bank-receipt/pages-bank-receipt.ts